export const SUCESS_MODAL_TEXT = {
  PAYMENT_SUCCESSFUL: 'Payment Successful',
  DESCRIPTION_CAD: 'You have successfully paid CAD',
  DESCRIPTION_USD: 'You have successfully paid USD',
  NOTIFICATION_EMAIL: 'The payees will receive a notification email from the system.',
  BACK_TO_PENDING_LIST: 'Back to Pending Payment List',
  AND_USD: 'and USD',
};
